<template>
 <div class="fc-page mg-page rp-page rp-class_attendance_rate">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>班级出勤率</h1><p>按班级和日期查看出勤情况与消课数据</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters" aria-label="报表筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>选择班级和日期范围</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid rp-date-grid">
   <div class="fc-filter-cell"><v-select :items="selectClassList" v-model="query.classId" item-text="className" item-value="id" label="班级" dense outlined clearable hide-details color="#d9363e" /></div>
   <div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" /></template><v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu></div>
   <div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" /></template><v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu></div>
  </div><div class="fc-filter-bottom"><span>日期范围最长 3 个月</span><div class="fc-filter-actions"><v-btn type="submit" color="#d9363e" dark depressed :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
  <section class="fc-records"><div class="fc-list-heading"><h3>班级出勤明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div>
   <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table rp-table" :mobile-breakpoint="0" disable-pagination hide-default-footer item-key="classId" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">
    <template v-slot:item.className="{item}"><span class="rp-class-name">{{item.className}}</span></template>
    <template v-slot:item.attendanceRate="{item}"><span class="rp-attendance-rate">{{Number(item.shouldComeCount) > 0 ? (item.realComeCount * 100 / item.shouldComeCount).toFixed(2) : '0.00'}}%</span></template>
   </v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e" /></div></section>
 </div>
</template>

<script>
	//班级出勤率统计
	import utils from "../../../config/utils"
	export default {
		name: "class-attendance-rate",
		components:{},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据分析',
						disabled: true
					},
					{
						text: '班级出勤率',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '班级名称',
							value: 'className',
							sortable: false,	
						},
						{
							text: '上课次数',
							value: 'recordCount',
							sortable: false,
						},
						
						{
							text: '应出勤人数',
							value: 'shouldComeCount',
							sortable: false,
										
						},
						{
							text: '实际出勤人数',
							value: 'realComeCount',
							sortable: false,
										
						},
						{
							text: '出勤率',
							value: 'attendanceRate',
							sortable: false,
										
						},
						{
							text: '消课时数',
							value: 'totalReduceQty',
							sortable: false,			
						},
						{
							text: '消课收入',
							value: 'totalRevenue',
							sortable: false,			
						},
					
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					classId: "",
				},
				
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.query.start = utils.getFirstDayOfMonth();
			this.query.end = utils.getLastDayOfMonth();
			
			this.getClassListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
		
			getTableDataList() {
				
				if(!this.query.start || !this.query.end){
					this.$noty.error("请选择日期范围");
					return
				}
				
				const diff = utils.diffDate(this.query.start,this.query.end);
				
				console.log(diff);
				
				if (diff > 93){
					this.$noty.error("日期范围最长3个月");
					return
				}
				
				
				const that = this;
				this.query.loading = true;
	
				const shopId = utils.getCurrentShopId();
	
				let url = `/data/class/attendance/rate/${this.query.page}/${this.query.size}?shopId=${shopId}`;
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				
				
				this.axios.get(url).then(response => {
	
					console.log(response);
	
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
	
						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
			getClassListForSelect(shopId) {
	
				if (!shopId) {
					return
				}
	
				const that = this;
				let url = `/edu/shop/class/list/` + shopId;
	
				this.axios.get(url).then(response => {
	
					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}
	
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		
	
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
